import moment from 'moment';
import mudder from 'mudder';

const testIdPrefix = "task:test."

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomPseudoText(wordCount = randInt(1, 8)) {
  let words = [];
  for (let i = 0; i < wordCount; i++) {
    const wordlen = randInt(1, 10);
    words.push(Math.random().toString(36).slice(2, wordlen + 2));
  }
  return words.join(' ');
}

function randomTestTaskId() {
  return testIdPrefix + Math.random().toString(36).substring(2);
}

function currentKeyForClass(pClass) {
  switch (pClass) {
    case 'week':
      return moment().startOf('isoWeek').format('Y-MM-DD');
    case 'list':
      return 'backlog';
    default:
      return moment().startOf(pClass).format('Y-MM-DD');
  }
}

function generateItem(
  pClass, pKey, seq, relName = "subtaskOf", archived = false, type = "task"
) {
  const doc = {
    "_id": randomTestTaskId(),
    "name": randomPseudoText(),
    "type": type,
    [relName]: {
      "parentClass": pClass,
      "parentKey": pKey,
      "seq": seq,
    }
  };
  if (archived) {
    doc.archivedTimestampMs = Date.now();
  }
  return doc;
}

function genSectionTasks(pClass, pKey, count, archived = false) {
  if (!count) return [];
  const seqs = mudder.base62.mudder('A', 'Z', count);
  return seqs.map(seq => generateItem(pClass, pKey, seq, "plannedFor", archived))
}

function genSubtasksForTask(parentId, count) {
  if (!count) return [];
  const seqs = mudder.base62.mudder('A', 'Z', count);
  return seqs.map(seq => generateItem("task", parentId, seq, "subtaskOf"))
}

function genToplevelTasks(count = 100) {
  let items = [];
  let generated = 0;
  const columns = ['day', 'week', 'month', 'list']
    .map(unit => [unit, currentKeyForClass(unit)])

  for (const column of columns) {
    let toGenerate = Math.min(count - generated, Math.ceil(count / columns.length))
    if (toGenerate) {
      items.push(...genSectionTasks(...column, toGenerate));
      generated += toGenerate
    }
  }
  return items;
}

function bulkGenSubtasks(parentIds, count) {
  const avgSubtasks = Math.round(count / (parentIds.length / 2))

  // Let one parent have a large amount of subtasks.
  let toGenerate = Math.min(avgSubtasks * 3, count)
  let items = [...genSubtasksForTask(parentIds[0], toGenerate)]
  let generated = toGenerate;

  for (const id of parentIds.slice(1)) {
    toGenerate = Math.min(
      randInt(Math.floor(avgSubtasks * 0.5), Math.ceil(avgSubtasks * 1.5)),
      count - generated,
    )
    items.push(...genSubtasksForTask(id, toGenerate))
    generated += toGenerate
    if (generated >= count) break;
  }
  return items
}

export async function populateCurrent(
  db, taskCount = 100, subtaskCount = 200, useLongNames = true
) {
  const parents = genToplevelTasks(taskCount)
  // Sorting by ids effectively randomizes further operations across columns.
  const parentIds = (await db.bulkDocs(parents)).map(row => row.id).sort()

  // Let some tasks (ones that are least likely to get subtasks) have long names.
  if (useLongNames) {
    for (let i = 1; i < 6; i++) {
      const doc = await db.get(parentIds[parentIds.length - 6 + i])
      doc.name = randomPseudoText(i * 20)
      await db.put(doc)
    }
  }

  const subtasks = bulkGenSubtasks(parentIds, subtaskCount)
  return await db.bulkDocs(subtasks)
}


// Cleanup.

export async function clearTestData(db) {
  const allDocs = (await db.allDocs({ include_docs: true })).rows
  const testTasks = allDocs
    .map(record => record.doc)
    .filter(doc => doc._id.startsWith(testIdPrefix))
  testTasks.forEach(doc => doc._deleted = true)
  await db.bulkDocs(testTasks)
}
